import { useUserInfo } from "@/hooks/useUserInfo.js"
const tabbarPage = ['/pages/index/index', '/pages/study/index', '/pages/member/index']

/**
 * 格式化页面路径，用于规范页面路径，已/开头
 * @param { string } path
 * @returns { string } 格式化后的页面路径
 */
function formatPath(path) {
	if (!path.startsWith('/')) {
		return '/' + path
	} else if (path.startsWith('//')) {
		return path.substring(1)
	} else {
		return path
	}
}

/**
 * 获取当前页面路径
 */
export function getPage() {
	const pages = getPages()
	return formatPath(pages[pages.length - 1]?.route ?? '')
}

/**
 * 获取当前页面完整路径（包含query）
 */
export function getFullPage() {
	const pages = getPages()
	// @ts-ignore
	return formatPath(pages[pages.length - 1]?.$page.fullPath ?? '')
}

/**
 * 获取当前页面请求参数
 */
export function getPageQuery() {
	const pages = getPages()
	// @ts-ignore
	return pages[pages.length - 1]?.options ?? {}
}

/**
 * 获取页面栈
 */
export function getPages() {
	return getCurrentPages()
}

/**
 * 是否有上级页面
 */
export function hasPrevPage() {
	const pages = getPages()
	return pages.length > 1
}

/**
 * 关闭骨架屏
 * @param { Ref<boolean> } loading
 */
export function removeSkeleton(loading) {
	loading.value = false






	return
}

/**
 * 是否tabbar页面
 */
export function isTabbar(path) {
	if (!path) {
		return tabbarPage.includes(getPage())
	} else {
		return tabbarPage.includes(formatPath(path))
	}
}

/**
 * 跳转首页
 */
export function goHome() {
	go('/pages/index/index')
}

/**
 * 路由跳转
 * @param { string } url
 * @param { object } params
 */
export function go(url, params = {}) {
	const formatUrl = formatPath(url)
	// 跳转
	uni.$u.route({
		type: isTabbar(formatUrl) ? 'switchTab' : 'navigateTo',
		url: formatUrl,
		params
	})
}

/**
 * 路由跳转(redirect)
 * @param { string } url
 * @param { object } params
 */
export function redirect(url, params = {}) {
	const formatUrl = formatPath(url)
	// 跳转
	uni.$u.route({
		type: isTabbar(formatUrl) ? 'switchTab' : 'redirectTo',
		url: formatUrl,
		params
	})
}

/**
 * 返回
 */
export function back() {
	if (hasPrevPage()) {
		uni.navigateBack()
	} else {
		goHome()
	}
}

/**
 * 跳转到驾考页面
 * @param { object } params 跳转参数
 * @param { object } params.id 跳转参数
 */
export function goDrive(params) {
	const app = getApp()
	app.globalData.driveProductId = params.id
	go('/pages_driving/driving/index', params)
}

/**
 * 跳转到橙知有好课
 */
export function goCourseKsGem() {
	const userInfo = useUserInfo()
	ks.navigateToMiniProgram({ appId: 'ks692991396131372694', path: getFullPage() + `&user_id=${userInfo.value.user_id}` })
}

/**
 * 跳转到其他小程序
 * @param { object } params 跳转参数
 * @param { string } params.appid 小程序appId
 * @param { string } params.path 小程序路径
 */
export function redirectOther(params) {
	const userInfo = useUserInfo()
	const query = getPageQuery()

	delete query.id
	delete query.course_id
	delete query.special_id

	const queryStr = Object.keys(query).map(key => `${key}=${query[key]}`).join('&')

	ks.navigateToMiniProgram({ appId: params.appid, path: params.path + queryStr + `&user_id=${userInfo.value.user_id}` })
}